// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section-planning .notes-modal {
  border-top: 1px solid #e0e5eb;
  padding-top: 24px;
}
.section-planning .notes-modal span {
  font-weight: bold;
}
.section-planning .box-title h3 {
  color: var(--sebrae-blue);
  font-size: 27px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.section-planning .box-title h5 {
  padding: 20px 0;
  color: #394d60;
  font-size: 23px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.section-planning .step {
  border-radius: 4px;
  border: 1px solid #b6bfc8;
  background: var(--sebrae-white);
  display: flex;
  height: 32px;
  flex-shrink: 0;
  margin: 15px 0;
}
.section-planning .step button {
  display: block;
  width: 50%;
  height: 100%;
}
.section-planning .step button:first-child {
  border-right: 1px solid #b6bfc8;
}
.section-planning .step button:last-child {
  border-left: 1px solid #b6bfc8;
}
.section-planning .step button.active {
  background-color: rgba(2, 94, 184, 0.7803921569);
  color: var(--sebrae-white);
}
.section-planning .search {
  position: relative;
}
.section-planning .search input {
  width: 100% !important;
}
.section-planning .search .icon {
  position: absolute;
  right: 10px;
  top: 8px;
  display: flex;
  align-items: center;
  height: calc(100% - 15px);
}
.section-planning .search .icon img {
  width: 15px;
  height: 15px;
}
.section-planning .search-date {
  padding-bottom: 50px;
  position: relative;
}
.section-planning .search-date p {
  color: #617385;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding-bottom: 10px;
}
.section-planning .search-date .date {
  display: flex;
  gap: 15px;
  position: relative;
  z-index: 1;
}
.section-planning .search-date .date img:before {
  content: "";
  width: 1px;
  height: 100%;
  background-color: red;
}
.section-planning .search-date .clear {
  text-align: right;
  padding: 10px 0;
  position: absolute;
  right: 0;
  bottom: 18px;
}
.section-planning .search-date .clear button {
  color: #006bff;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}
.section-planning .more-planning {
  text-align: center;
  margin-bottom: 30px;
}
.section-planning .more-planning button {
  color: var(--sebrae-blue);
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
}
.section-planning .list-planing .empty {
  display: flex;
  gap: 15px;
}
@media (min-width: 560px) {
  .section-planning .wrapper-search {
    max-width: 500px;
  }
  .section-planning .wrapper-search .date > div {
    width: 100%;
  }
}

.driver-popover {
  max-width: 343px !important;
  font-size: 16px !important;
  border: 2px solid #cfe2fc;
  border-radius: 4px !important;
  padding: 16px;
  background-color: var(--sebrae-white) !important;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
}

.driver-popover-title {
  border-bottom: 1px solid var(--sebrae-light-gray-2);
}

.driver-popover-prev-btn {
  display: none;
}

.driver-popover-next-btn {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 13px !important;
  min-height: 32px !important;
  min-width: 71px !important;
  border-radius: 4px !important;
  border: 1px solid #005eb8 !important;
  color: #005eb8 !important;
}

.driver-popover-description {
  margin-top: 20px !important;
}

.driver-popover-footer {
  margin-top: 20px !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/my-planning/index.scss"],"names":[],"mappings":"AACE;EACE,6BAAA;EACA,iBAAA;AAAJ;AAEI;EACE,iBAAA;AAAN;AAKI;EACE,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAHN;AAMI;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAJN;AAQE;EACE,kBAAA;EACA,yBAAA;EACA,+BAAA;EAEA,aAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AAPJ;AASI;EACE,cAAA;EACA,UAAA;EACA,YAAA;AAPN;AASM;EACE,+BAAA;AAPR;AASM;EACE,8BAAA;AAPR;AAUM;EACE,gDAAA;EACA,0BAAA;AARR;AAaE;EACE,kBAAA;AAXJ;AAaI;EACE,sBAAA;AAXN;AAaI;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AAXN;AAaM;EACE,WAAA;EACA,YAAA;AAXR;AAgBE;EACE,oBAAA;EACA,kBAAA;AAdJ;AAgBI;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;AAdN;AAiBI;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;AAfN;AAkBQ;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,qBAAA;AAhBV;AAqBI;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;AAnBN;AAqBM;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,+BAAA;EACA,4BAAA;EACA,8BAAA;EACA,+BAAA;EACA,2BAAA;EACA,kCAAA;AAnBR;AAwBE;EACE,kBAAA;EACA,mBAAA;AAtBJ;AAwBI;EACE,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,+BAAA;AAtBN;AA2BI;EACE,aAAA;EACA,SAAA;AAzBN;AA6BE;EACE;IACE,gBAAA;EA3BJ;EA8BM;IACE,WAAA;EA5BR;AACF;;AAkCA;EACE,2BAAA;EACA,0BAAA;EACA,yBAAA;EACA,6BAAA;EACA,aAAA;EACA,gDAAA;EACA,2CAAA;AA/BF;;AAkCA;EACE,mDAAA;AA/BF;;AAkCA;EACE,aAAA;AA/BF;;AAkCA;EACE,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,0BAAA;EACA,2BAAA;EACA,0BAAA;EACA,6BAAA;EACA,oCAAA;EACA,yBAAA;AA/BF;;AAkCA;EACE,2BAAA;AA/BF;;AAkCA;EACE,2BAAA;AA/BF","sourcesContent":[".section-planning {\n  .notes-modal {\n    border-top: 1px solid #e0e5eb;\n    padding-top: 24px;\n\n    span {\n      font-weight: bold;\n    }\n  }\n\n  .box-title {\n    h3 {\n      color: var(--sebrae-blue);\n      font-size: 27px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n    }\n\n    h5 {\n      padding: 20px 0;\n      color: #394d60;\n      font-size: 23px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n    }\n  }\n\n  .step {\n    border-radius: 4px;\n    border: 1px solid #b6bfc8;\n    background: var(--sebrae-white);\n\n    display: flex;\n    height: 32px;\n    flex-shrink: 0;\n    margin: 15px 0;\n\n    button {\n      display: block;\n      width: 50%;\n      height: 100%;\n\n      &:first-child {\n        border-right: 1px solid #b6bfc8;\n      }\n      &:last-child {\n        border-left: 1px solid #b6bfc8;\n      }\n\n      &.active {\n        background-color: #025eb8c7;\n        color: var(--sebrae-white);\n      }\n    }\n  }\n\n  .search {\n    position: relative;\n\n    input {\n      width: 100% !important;\n    }\n    .icon {\n      position: absolute;\n      right: 10px;\n      top: 8px;\n      display: flex;\n      align-items: center;\n      height: calc(100% - 15px);\n\n      img {\n        width: 15px;\n        height: 15px;\n      }\n    }\n  }\n\n  .search-date {\n    padding-bottom: 50px;\n    position: relative;\n\n    p {\n      color: #617385;\n      font-size: 13px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n      padding-bottom: 10px;\n    }\n\n    .date {\n      display: flex;\n      gap: 15px;\n      position: relative;\n      z-index: 1;\n\n      img {\n        &:before {\n          content: \"\";\n          width: 1px;\n          height: 100%;\n          background-color: red;\n        }\n      }\n    }\n\n    .clear {\n      text-align: right;\n      padding: 10px 0;\n      position: absolute;\n      right: 0;\n      bottom: 18px;\n\n      button {\n        color: #006bff;\n        font-size: 13px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n        text-decoration-line: underline;\n        text-decoration-style: solid;\n        text-decoration-skip-ink: none;\n        text-decoration-thickness: auto;\n        text-underline-offset: auto;\n        text-underline-position: from-font;\n      }\n    }\n  }\n\n  .more-planning {\n    text-align: center;\n    margin-bottom: 30px;\n\n    button {\n      color: var(--sebrae-blue);\n      font-size: 13px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n      text-decoration-line: underline;\n    }\n  }\n\n  .list-planing {\n    .empty {\n      display: flex;\n      gap: 15px;\n    }\n  }\n\n  @media (min-width: 560px) {\n    .wrapper-search {\n      max-width: 500px;\n\n      .date {\n        & > div {\n          width: 100%;\n        }\n      }\n    }\n  }\n}\n\n.driver-popover {\n  max-width: 343px !important;\n  font-size: 16px !important;\n  border: 2px solid #cfe2fc;\n  border-radius: 4px !important;\n  padding: 16px;\n  background-color: var(--sebrae-white) !important;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);\n}\n\n.driver-popover-title {\n  border-bottom: 1px solid var(--sebrae-light-gray-2);\n}\n\n.driver-popover-prev-btn {\n  display: none;\n}\n\n.driver-popover-next-btn {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  font-size: 13px !important;\n  min-height: 32px !important;\n  min-width: 71px !important;\n  border-radius: 4px !important;\n  border: 1px solid #005eb8 !important;\n  color: #005eb8 !important;\n}\n\n.driver-popover-description {\n  margin-top: 20px !important;\n}\n\n.driver-popover-footer {\n  margin-top: 20px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
